import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useLazyQuery, gql, useMutation } from "@apollo/client";
import { MEMBER_ID } from "../graphql/queries/Patients";
import { UPLOAD_DOCUMENT } from "../graphql/mutations/Providers";
import $ from "jquery";

import "../upload/js/fileinput.js";
export default function DocumentSubmission(props) {
  const cancelpage = props.cancel;
  const uploadSource = props.uploadSource;
  const [docSubmitted, setstatus] = useState(false);
  const [doc_type, setdoctype] = useState("EOB");
  const [program, setprogram] = useState("XOLAIR");
  const [member_id, setmemberid] = useState("");
  const [doc_id, setdocid] = useState([]);

  const patient_id = parseInt(window.localStorage.getItem("xrefID"));
	const xref_id = parseInt(window.localStorage.getItem('xrefID'))
  const provider_id = parseInt(window.localStorage.getItem("providerID"));

  const { loading, error, data } = useQuery(MEMBER_ID, {
    variables: { patient_id },
  });
  const [tooManyFiles, setTooManyFiles] = useState(false);

 useEffect(() => {
  $("#input-ficons-6").fileinput({
    theme: "fas",
    uploadUrl: "file-upload.js",
    uploadAsync: false,
    showRemove: false,
    showUpload: false,
    maxFileSize: 5120,
    allowedFileExtensions: ["pdf", "jpg", "jpeg", "png", "tiff"], 
    previewFileIcon: '<i class="fas fa-file"></i>',
    browseIcon: '<i class="fas fa-folder-open"></i>',
    browseClass: "btn btn-primary",
    removeIcon: '<i class="fas fa-trash-alt"></i>',
    cancelIcon: '<i class="fas fa-ban"></i>',
    pauseIcon: '<i class="fas fa-pause"></i>',
    uploadIcon: '<i class="fas fa-upload"></i>',
    preferIconicZoomPreview: true,
    previewFileIconSettings: {
      jpg: '<i class="fas fa-file-image text-danger"></i>',
      gif: '<i class="fas fa-file-image text-warning"></i>',
      png: '<i class="fas fa-file-image text-primary"></i>',
    },
    layoutTemplates: {
      fileIcon: '<i class="fas fa-file kv-caption-icon"></i> ',
    },
    dropZoneTitle: "",
    previewZoomButtonIcons: {
      prev: '<i class="fas fa-caret-left fa-lg"></i>',
      next: '<i class="fas fa-caret-right fa-lg"></i>',
      toggleheader: '<i class="fas fa-fw fa-arrows-alt-v"></i>',
      fullscreen: '<i class="fas fa-fw fa-arrows-alt"></i>',
      borderless: '<i class="fas fa-fw fa-external-link-alt"></i>',
      close: '<i class="fas fa-fw fa-times"></i>',
    },
    fileActionSettings: {
      removeIcon: '<i class="fas fa-trash-alt"></i>',
      uploadIcon: false,
      showUpload: false,
      uploadRetryIcon: '<i class="fas fa-redo-alt"></i>',
      downloadIcon: '<i class="fas fa-download"></i>',
      zoomIcon: '<i class="fas fa-search-plus"></i>',
      dragIcon: '<i class="fas fa-arrows-alt"></i>',
      indicatorNew: '<i class="fas fa-plus-circle text-warning"></i>',
      indicatorSuccess: '<i class="fas fa-check-circle text-success"></i>',
      indicatorError: '<i class="fas fa-exclamation-circle text-danger"></i>',
      indicatorLoading: '<i class="fas fa-hourglass text-muted"></i>',
      indicatorPaused: '<i class="fa fa-pause text-info"></i>',
    },
  })
}, []);


  useEffect(() => {
    updateDocID(doc_id);
  }, [doc_id.length]);

  function updateDocID(docid) {
    setdocid(docid);
  }

  useEffect(() => {
    if (data) {
      if (data.patientinfo != null) {
        if (data.patientinfo.member_id) {
          setmemberid(data.patientinfo.member_id);
        }
      }
    }
  }, [data]);

  let navigate = useNavigate();
  function cancelBtn() {
    let path = `../` + cancelpage;
    navigate(path);
  }

  var filestack;
  var fstack;
  const [uploadDocunent] = useMutation(UPLOAD_DOCUMENT);

  async function submitDoc(e) {
    e.preventDefault();

    filestack = $("#input-ficons-6").fileinput("getFileStack");
    fstack = [];

    $.each(filestack, function (fileId, fileObj) {
      if (fileObj !== undefined) {
        fstack.push(fileObj);
      }
    });

    if (doc_type != "") {
      if (fstack.length > 0) {
        await fileUpload();

      } else {
      }
    } else {
    }
  }
async function fileUpload() {
    if (fstack.length > 5) {
      setTooManyFiles(true);
    }else{
  const arr = [];
    $("#submitbtn").attr("disabled", true);
  for (let index = 0; index < fstack.length; index++) {
    const extension = fstack[index]?.file?.name?.substring(fstack[index]?.file?.name?.lastIndexOf("."));
    try {
      const { data: uploadedData } = await uploadDocunent({
        variables: {
          input: {
            memberID: member_id,
            patient_id: patient_id|| xref_id,
            docType: doc_type,
            program: program,
            file_type: fstack[index]?.file?.type,
            file_extension: extension,
            provider_id: provider_id,
            uploadSource: uploadSource,
          },
        },
      });
      const fileUrl = uploadedData.patientuploaddocuments.url;
      const docId = uploadedData.patientuploaddocuments.document_id;
      const file = fstack[index]?.file;
      const requestOptions = {
        method: "PUT",
        body: file,
      }
      const response = await fetch(fileUrl, requestOptions);
      if (!response.ok){
         throw new Error(`Upload failed: ${response.status}`);
      }
      arr.push({ value: docId });
       $("#input-ficons-6").fileinput("clear");
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  }
  setstatus(true);
  $("#submitbtn").attr("disabled", false);
   
	    setdocid(arr);
    }
}




  return (
    <div className="section shadow-box color-label">
      <div className="col-sm-12 col-md-12 col-lg-12">
        <h2>Document</h2>
        <div>
          <p>The requirements for reimbursement must include:</p>
          <ul className="mb-4" style={{ marginLeft: "40px" }}>
            <li>Name of health insurance company</li>
            <li>Facility name</li>
            <li>Patient's name</li>
            <li>Date of service (DOS)</li>
            <li>Name of drug or J-code</li>
            <li>Amount billed, amount allowed, patient responsibility, amount paid to provider</li>
          </ul>
          If the Explanation of Benefits (EOB) does not include any of the above items, additional documentation may be required
          to process the claim.
        </div>
        <p>All fields are mandatory unless otherwise indicated.</p>
        <form encType="multipart/form-data" acceptCharset="utf-8" onSubmit={(e) => submitDoc(e)}>
          <p>
            <span className="color">Please select the product to upload a document for:</span>{" "}
          </p>
          <div className="col-sm-12 col-md-12 col-lg-3">
            <p>
              <label style={{ color: "#888" }}>Product</label>
              <br />
              <span className="select_container">
                <select name="product" defaultValue="XR" onChange={(e) => setprogram(e.target.value)}>
                  <option value="XR">XOLAIR</option>
                  <option value="XRA">XOLAIR ADMINISTRATION</option>
                </select>
              </span>
            </p>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <section>
              <div className="submitDocument">
                <div className="color info">
                  <h2>Information</h2>
                  <p>
                    You can upload a maximum of 5 files at one time (max size per file is 5MB).
                    <br /> Multiple pages are combined into one EOB, etc.
                    <br />
                    Allowed file types: jpg/jpeg, png, pdf.
                  </p>
                </div>
                <div className="file-loading">
                  <input
                    id="input-ficons-6"
                    name="input-ficons-6[]"
                    multiple
                    type="file"
                    data-theme="fas"
                  />
                </div>
                <p>
                  <label>&nbsp;</label>
                  <button id="submitbtn" type="submit" value="" name="find" className="fltrt noTopSpace">
                    Submit
                  </button>{" "}
                  <button type="reset" value="" name="find" className="cancel" onClick={cancelBtn}>
                    Cancel
                  </button>
                </p>
              </div>
              {tooManyFiles ? <p>Maximum of 5 files at one time</p> : <></>}
              {docSubmitted == true ? DocumentID(doc_id) : <></>}
            </section>
          </div>
        </form>
      </div>
    </div>
  );
}

function DocumentID(doc_id) {
  return <>{doc_id && doc_id.map((document) => <p key={doc_id}>Document ID {document.value} submitted</p>)}</>;
}



